"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductVariant = void 0;
/**
 * Discriminates card-backed from cardless debt products on the account-overview wire so the
 * frontend never has to infer the variant from card-field presence. Orthogonal to
 * AvenCardProductType: auto/crypto/UCC are cardBacked; any product can grow a cardless variant.
 */
var ProductVariant;
(function (ProductVariant) {
    ProductVariant["cardBacked"] = "cardBacked";
    ProductVariant["cardless"] = "cardless";
})(ProductVariant || (exports.ProductVariant = ProductVariant = {}));
